import { Navigate, useLocation } from 'react-router';
import { useSelector } from 'react-redux';
import { ROUTES } from './routePaths';

export default function ProtectedRoute({ children, allowedRoles }) {
  const { user, loading } = useSelector((state) => state.auth);
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        Loading...
      </div>
    );
  }

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} state={{ from: location }} replace />;
  }

  if (allowedRoles && !allowedRoles.includes(user.role)) {
    // For now we only have admin dashboard; fallback to ROOT
    return <Navigate to={ROUTES.ROOT} replace />;
  }

  return children;
}